import LocalStorageService from '../../LocalStorage/LocalStorage.service';
import Dates from '../../../utils/dates';
import { SURVEY_BASE_URL } from '../../../constants';

const MAX_AUTHORIZATIONS = 50;
const WAIT_DAYS = 30;

const SurveyAuthorizationService = {
  surveyURL: `${SURVEY_BASE_URL}/jfe/form/SV_cAsdc3Z4eK2KvuS`,

  getAuthorizationsQuantity: () => LocalStorageService.get('authorizationsQuantity'),

  setAuthorizationsQuantity: (value) => LocalStorageService.set('authorizationsQuantity', value),

  getLastQualtricsSurveyResponse: () => LocalStorageService.get('lastAuthorizationsSurveyResponse'),

  setLastQualtricsSurveyResponse: (value) =>
    LocalStorageService.set('lastAuthorizationsSurveyResponse', value),

  showByAuthorizationsQuantity: () =>
    SurveyAuthorizationService.getAuthorizationsQuantity() >= MAX_AUTHORIZATIONS,

  restartAuthorizationsQuantity: () => SurveyAuthorizationService.setAuthorizationsQuantity(0),

  incrementAuthorizationsQuantity: () => {
    const currentQuantity = SurveyAuthorizationService.getAuthorizationsQuantity();
    SurveyAuthorizationService.setAuthorizationsQuantity(currentQuantity + 1);
  },

  saveAuthorizationAction: () => {
    SurveyAuthorizationService.incrementAuthorizationsQuantity();
  },

  showByDate: () => {
    const nextDateShowSurvey = Dates.getWithAddDays(
      WAIT_DAYS,
      new Date(SurveyAuthorizationService.getLastQualtricsSurveyResponse() ?? ''),
    ).toDate();
    return Dates.get().compareIsAfter(nextDateShowSurvey);
  },

  checkFirstTime: () =>
    !SurveyAuthorizationService.getAuthorizationsQuantity() ||
    !SurveyAuthorizationService.getLastQualtricsSurveyResponse(),

  checkShowByConstraints: () =>
    SurveyAuthorizationService.showByAuthorizationsQuantity() ||
    SurveyAuthorizationService.showByDate(),

  checkShowSurvey: () =>
    SurveyAuthorizationService.checkShowByConstraints() ||
    SurveyAuthorizationService.checkFirstTime(),
};

export default SurveyAuthorizationService;
